import React from 'react';
import './AccountCodesList.css';

function AccountCodesList({ accountCodes, loading }) {
  const getTypeIcon = (type) => {
    const icons = {
      password: '🔑',
      verification: '✅',
      activation: '🚀',
      reset: '🔄',
      login: '🔓',
      signup: '📝',
      otp: '⏱️',
      other: '🔐'
    };
    return icons[type] || '🔐';
  };

  const getTypeLabel = (type) => {
    return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Other';
  };

  const copyToClipboard = (text) => {
    // Extract potential codes from the text
    const codeMatch = text.match(/\b[A-Z0-9]{4,}\b/g);
    const textToCopy = codeMatch ? codeMatch.join(', ') : text;
    
    navigator.clipboard.writeText(textToCopy);
    alert('Copied to clipboard!');
  };

  if (loading) {
    return <div className="loading">Loading account codes...</div>;
  }

  if (accountCodes.length === 0) {
    return (
      <div className="empty-state">
        <h3>No Account Codes Found</h3>
        <p>Your account-related emails will appear here.</p>
      </div>
    );
  }

  return (
    <div className="account-codes-grid">
      {accountCodes.map((code) => (
        <div key={code._id} className="account-code-card">
          <div className="account-code-header">
            <span className="code-type-icon">{getTypeIcon(code.codeType)}</span>
            <span className="code-type-label">{getTypeLabel(code.codeType)}</span>
            <span className="code-date">{new Date(code.date).toLocaleDateString()}</span>
          </div>
          
          <div className="account-code-content">
            <h4>{code.subject}</h4>
            <p className="code-from">From: {code.from}</p>
            
            <div className="code-body">
              {code.body.substring(0, 200)}
              {code.body.length > 200 && '...'}
            </div>
          </div>
          
          <div className="account-code-actions">
            <button 
              className="copy-btn"
              onClick={() => copyToClipboard(code.body)}
            >
              📋 Copy Code
            </button>
            <button 
              className="view-btn"
              onClick={() => {
                const modal = document.createElement('div');
                modal.className = 'modal';
                modal.innerHTML = `
                  <div class="modal-content">
                    <h3>${code.subject}</h3>
                    <p><strong>From:</strong> ${code.from}</p>
                    <p><strong>Date:</strong> ${new Date(code.date).toLocaleString()}</p>
                    <div class="modal-body">${code.body.replace(/\n/g, '<br>')}</div>
                    <button onclick="this.parentElement.parentElement.remove()">Close</button>
                  </div>
                `;
                document.body.appendChild(modal);
              }}
            >
              👁️ View Full
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default AccountCodesList;
